<script>
import OrdersApi from "@/services/orders-api";

export default {
      props: {
        isMonthly: {
            type: Boolean,
            default: false,
        },
        isYearly :{
            type: Boolean,
            default: false,
        },

        currentMonth:Number,
        currentYear:Number
    },
  mounted(){
    this.role=sessionStorage.getItem("userr");
    this.getTotalTurnover();
  },
  data() {
    return {
      role: null,
      month:this.currentMonth,
      year:this.currentYear,
      monthly_turnover:0,
      yearly_turnover:0,
      increase:null,
      increaseAsString:null,

    };


  },

  methods: {
    getTotalTurnover(){
        OrdersApi.getTotalTurnover(this.month,this.year,this.isMonthly,this.isYearly).then(
            (result)=>{
              if(this.isMonthly){
                this.monthly_turnover =result.selectedPeriodValueAsString ===null ? 0 : result.selectedPeriodValueAsString
                this.increase=result.increase
                this.increaseAsString=result.increaseAsString
              }

              if(this.isYearly){
                this.yearly_turnover =result.selectedPeriodValueAsString ===null ? 0 : result.selectedPeriodValueAsString
                this.increase=result.increase
                this.increaseAsString=result.increaseAsString
              }
                
            }
        )
    },


},
    watch : {
        year : function() {
              this.getTotalTurnover() 
        },
        month : function() {
              this.getTotalTurnover() 
        }
  }

};
</script>

<template>
  <div class="card mini-stats-wid mt-2 mb-2 border border-light " :class="isMonthly ? 'mr-lg-2' : 'ml-lg-2'">
    <div class="card-body  p-0 ">
      <div class="media">
        <div class="media-body">
        <div class="clearfix m-4">
            <div class="float-right ">
            <div v-if="isMonthly" class="input-group input-group-sm">
                <select class="custom-select custom-select-sm"  v-model="month">
                  <option v-if="currentMonth>=0" selected value="0">Janv</option>
                  <option v-if="currentMonth>=1" value="1">Févr</option>
                  <option v-if="currentMonth>=2" value="2">Mars</option>
                  <option v-if="currentMonth>=3" value="3">Avr</option>
                  <option v-if="currentMonth>=4" value="4">Mai</option>
                  <option v-if="currentMonth>=5" value="5">Juin</option>
                  <option v-if="currentMonth>=6" value="6">Juil</option>
                  <option v-if="currentMonth>=7" value="7">Août</option>
                  <option v-if="currentMonth>=8" value="8">Sept</option>
                  <option v-if="currentMonth>=9" value="9">Oct</option>
                  <option v-if="currentMonth>=10" value="10">Nov</option>
                  <option v-if="currentMonth>=11" value="11">Déc</option>
                </select>
                <div class="input-group-append">
                <label class="input-group-text">Mois</label>
                </div>
            </div>
        <div v-if="isYearly" class="input-group input-group-sm"> 
            <select class="custom-select custom-select-sm" v-model="year">
              <option selected :value="this.currentYear">{{this.currentYear}}</option>
              <option v-for="year in Array.from({length: this.currentYear -1 - 2019}, (value, index) => 2020 + index).reverse()" :key="year" :value="year">{{ year }}</option>
              <!-- <option  :value="{{this.currentYear-1}}"></option> -->
            </select>
          <div class="input-group-append">
              <label class="input-group-text">Année</label>
        </div>
      </div>
            </div>
    
    <h4 v-if="isMonthly && role==0" class="card-title text-primary font-size-16 mb-4">Volume d'Achats <span class="font-size-18">Mensuel<span class="font-size-12 pl-1">(HT, {{this.currentYear}})</span></span></h4>
    <h4 v-if="isMonthly && role==1" class="card-title text-primary font-size-16 mb-4"><span class="d-none d-sm-inline">Chiffre d'Affaires</span><span class="d-sm-none">CA</span> <span class="font-size-18">Mensuel <span class="font-size-12">(HT, {{this.currentYear}})</span></span></h4>
    <h4 v-if="isMonthly && role==2" class="card-title text-primary font-size-16 mb-4">Volume d’achat global <span class="font-size-18">Mensuel <span class="font-size-12 pl-1">(HT, {{this.currentYear}})</span></span></h4>

    <h4 v-if="isYearly && role==0" class="card-title text-primary font-size-16 mb-4">Volume d'Achats <span class="font-size-18">Annuel</span><span class="font-size-12 pl-1">(HT)</span></h4>
    <h4 v-if="isYearly && role==1" class="card-title text-primary font-size-16 mb-4"><span class="d-none d-sm-inline">Chiffre d'Affaires</span><span class="d-sm-none">CA</span> <span class="font-size-18">Annuel  <span class="font-size-12">(HT)</span></span></h4>
    <h4 v-if="isYearly && role==2" class="card-title text-primary font-size-16 mb-4">Volume d’achat global <span class="font-size-18">Annuel <span class="font-size-12">(HT)</span></span></h4>

        </div>
  <div class="row"  >
  <div  v-if="isMonthly" class="col-sm-6" style =" padding-left:26px">
  <h3   >{{this.monthly_turnover}} TND</h3>
  <p :class="increase == null ? 'invisible' :'' " class="text-muted font-size-14" >
    <span  :class="increase>0 ?'text-success mr-2' : 'text-danger mr-2'">
       {{Math.round(increase)}}%
      <i :class="increase>0 ?'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></i>
    </span>% au mois précédent
  </p>
  </div>
    <div v-if="isYearly" class="col-sm-6" style =" padding-left:26px">
  <h3  >{{this.yearly_turnover}} TND</h3>

    <p :class="increase == null ? 'invisible' :'' "  class="text-muted font-size-14">
    <span :class="increase>0 ?'text-success mr-2' : 'text-danger mr-2'">
      {{Math.round(increase)}}%
      <i :class="increase>0 ?'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></i>
    </span>% à l'année precédente
  </p>

  </div>
  <div class="col-sm-3"> </div>
  <div class="col-sm-3" >
        <div class="mini-stat-icon avatar-sm align-self-center rounded-circle float-right m-4 d-none d-sm-block ">
          <span class="avatar-title">
            <i v-if="isYearly" class="fas fa-dollar-sign font-size-24"></i>
            <i v-if="isMonthly" class="fas fa-file-invoice-dollar   font-size-24"></i>
          </span>
        </div>
  </div>
          </div>
        </div>


      </div>
    </div>
    <!-- end card-body -->
  </div>
</template>